import type { TranslatedInvestigationCatalogueItem } from "$routes/patient/[:patientId]/investigations/_lib/util";
import {
  convertOrderedSchema,
  type OrderedJSONSchema,
  parseSchema,
} from "@elephant-healthcare/yupify";
import type { InvestigationActivityItem } from "elephant-web/gql";
import { clone } from "ramda";
import type { AnyObjectSchema } from "yup";

export default function parseInvestigationSchema(
  investigation:
    | InvestigationActivityItem
    | TranslatedInvestigationCatalogueItem,
): AnyObjectSchema {
  if (!investigation.result) {
    const error = new Error(
      `No result schema for investigation with coding: ${
        investigation.coding?.loinc?.code ??
        investigation.coding?.elephant?.code
      }`,
    );
    throw error;
  }

  const nonOrderedSchema = convertOrderedSchema(
    investigation.result.resultSchema as OrderedJSONSchema,
  );
  return parseSchema(clone(nonOrderedSchema));
}
